
import dayjs from 'dayjs';
import 'dayjs/locale/es';


export const obtenerCuotasDeberiaTener = ({bolsillo, totalAhorro, cuotaNormal}) =>{
    dayjs.locale('es');

    const inicio = dayjs(bolsillo.fecha);
    const fin = dayjs();

// Resultado entero (redondeado hacia abajo)
    const mesesCompletos = fin.diff(inicio, 'month', true);




    return Math.ceil(mesesCompletos)


}